import { ApiProperty } from "@nestjs/swagger";

export class AttendanceAdjustRequest{
    @ApiProperty()
    employeeCode:string;

    @ApiProperty()
    date:string;
}